export const GET_LEARNER_REQUEST = "GET_LEARNER_REQUEST";
export const GET_LEARNER_SUCCESS = "GET_LEARNER_SUCCESS";
export const GET_LEARNER_FAILURE = "GET_LEARNER_FAILURE";

export const UPDATE_LEARNER_REQUEST = "UPDATE_LEARNER_REQUEST";
export const UPDATE_LEARNER_SUCCESS = "UPDATE_LEARNER_SUCCESS";
export const UPDATE_LEARNER_FAILURE = "UPDATE_LEARNER_FAILURE";

export const GET_CURRENT_LEARNER_REQEST = "GET_CURRENT_LEARNER_REQEST";
export const GET_CURRENT_LEARNER_SUCCESS = "GET_CURRENT_LEARNER_SUCCESS";
export const GET_CURRENT_LEARNER_FAILURE = "GET_CURRENT_LEARNER_FAILURE";

export const GET_MY_ENROLLED_COURSES_REQUEST =
  "GET_MY_ENROLLED_COURSES_REQUEST";
export const GET_MY_ENROLLED_COURSES_SUCCESS =
  "GET_MY_ENROLLED_COURSES_SUCCESS";
export const GET_MY_ENROLLED_COURSES_FAILURE =
  "GET_MY_ENROLLED_COURSES_FAILURE";

export const RESET_ALL_ACTIONS = "RESET_ALL_ACTIONS";
